export const es = {
  translation: {
    "vehicle_in_all_places": "Veículos em qualquer lugar do Brasil"
  }
} 